import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { FiAppSettings } from '@fi-shared/fi-app-settings';

@Component({
    selector: 'fi-customer-billing-invoice-bank-info',
    template: `
        <div class="BankText">
            <p>
                <strong>{{ 'common.bank' | fiAppText }}</strong>
            </p>
            <p>{{ getInvoiceBankInfo() }}</p>
            <p>{{ 'billing.reverse_charge_procedures' | fiAppText }}</p>
        </div>
        <table class="InvoiceInfoFooter">
            <tr>
                <td class="Left">
                    <div>Chainformation AB</div>
                    <div>Ranbergagatan 25</div>
                    <div>212 30 Malm&#246;</div>
                    <div>Sweden</div>
                </td>
                <td class="Center">
                    <div>{{ 'common.phone' | fiAppText }}: +46 (0)40 17 21 92</div>
                    <div>{{ 'common.email' | fiAppText }}: invoice&#64;chainformation.com</div>
                    <div>{{ 'common.web' | fiAppText }}: www.chainformation.com</div>
                    <div>{{ 'billing.registred_for_tax' | fiAppText }}</div>
                </td>
                <td class="Right">
                    <div>{{ 'billing.bankgiro' | fiAppText }}: 5565-9486</div>
                    <div>{{ 'billing.cin' | fiAppText }}: 556591-2432</div>
                    <div>{{ 'billing.vat_no' | fiAppText }}: SE556591243201</div>
                    <div>{{ 'billing.credit_management_text' | fiAppText }}</div>
                </td>
            </tr>
        </table>
    `,
    styleUrls: ['./customer-billing-invoice-bank-info.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-customer-billing-invoice-bank-info' },
    standalone: false,
})
export class CustomerBillingInvoiceBankInfoComponent implements OnInit {
    constructor(private appTextService: AppTextService) {}

    ngOnInit(): void {}

    getInvoiceBankInfo() {
        return this.appTextService.get('billing.invoice_bank_info', {
            '{account_no}': FiAppSettings.Billing.AccountNo,
            '{bic}': FiAppSettings.Billing.BIC,
            '{iban}': FiAppSettings.Billing.IBAN,
        });
    }
}
